<template>
  <div>
    <audio src="@/assets/sound.wav" id ="audio"></audio>
    <div class="stepbar">
      <div class="stepbar_progress toppageStepBar">
        <div class="stepbar_track"></div>
        <div id="step1" class="stepbar_step" :class="{ 'is-active': !file, 'is-complete': file }">
          <p class="step_dropfile">DROP YOUR FILE</p>
          <div class="success-checkmark">
            <div class="check-icon">
              <span class="icon-line line-tip"></span>
              <span class="icon-line line-long"></span>
              <div class="icon-circle"></div>
            </div>
          </div>
          <!-- <span v-if="hover">複数のファイルをアップロードできません</span> -->
        </div>

        <div id="step2" class="stepbar_step" :class="{ 'is-active': file }">
          <p class="step_complete">COMPLETE</p>
          <div class="success-checkmark">
            <div class="check-icon"></div>
            <span class="icon-line line-tip"></span>
            <span class="icon-line line-long"></span>
            <div class="icon-circle"></div>
          </div>
        </div>
      </div>
    </div>
    <transition name="circle_anim" mode="out-in">
      <div class="uploadArea" v-if="!file">
        <form class="formArea" method="post" action enctype="multipart/form-data">
          <div class="toppageCircle">
            <!-- <div class="toppageCircle" @mouseover="hover = true" @mouseleave="hover = false"> -->
            <!-- <input type="file" id="file" ref="file" title @change="selectFile" multiple /> -->
            <input type="file" id="file" ref="file" title @change="selectFile" />
            <svg viewBox="0 0 100 100" style="display: block; width: 100%;">
              <path
                d="M 50,50 m 0,-49 a 49,49 0 1 1 0,98 a 49,49 0 1 1 0,-98"
                stroke="#f2f2ee"
                stroke-width="1.5"
                fill="#dfdedb"
                fill-opacity="1"
                style="stroke-dasharray: 307.919, 307.919; stroke-dashoffset: 0;"
              />
            </svg>
            <img src="@/assets/images/upload.svg" alt="アップロード" class="upload_icon" />
          </div>
        </form>
      </div>
    </transition>
    <transition name="circle_anim" mode="out-in">
      <div v-if="file">
        <fpUploadCircle :upload-file="file" />
      </div>
    </transition>
    <transition name="circle_anim" mode="out-in">
      <a class="delete_iconX" @click="file = !file" v-if="file"></a>
    </transition>
  </div>
</template>

<script>
export default {
  name: "uploadFile",
  data() {
    return {
      file: ""
      // hover: false
    };
  },
  // 複数ファイルをアップロードするときのalert
  // methods: {
  //   selectFile(e) {
  //     this.file = this.$refs.file.files[0];

  //     if (file.files.length >= 2) {
  //       e.preventDefault();
  //       alert("ファイル選択_複数のファイルをアップロードできません");
  //       return;
  //     }
  //   }
  // },
  // mounted: function() {
  //   $(".toppageCircle").on("drop", function(e) {
  //     if (e.originalEvent.dataTransfer.files.length >= 2) {
  //       e.preventDefault();
  //       alert("ドラッグ_複数のファイルをアップロードできません");
  //       return;
  //     }
  //   });
  // }
  methods: {
    selectFile(e) {
      this.file = this.$refs.file.files[0];
    }
  }
};
</script>

<style scoped lang="scss"></style>
